import React, { useContext } from 'react';
import LiveContext from '../../../../contexts/LiveContext';
import { getLabel } from '../../../../data/labels';
import { FavoritesContext } from '../../../FavoritesContextProvider';
import PreferitiSportItem from './PreferitiSportItem';
import { getConfiguration } from '../../../../data/utils';

export function getPreferiti(data, favoritesMap) {
    let matchesCount = 0;
    const preferitiSports = [];
    data && data.sport.forEach(function(sport) {
        const preferitiCountries = [];
        sport.categories.forEach(function(country, i) {
            const preferitiTournaments = [];
            country.tournaments.forEach(function(tournament, i) {
                const matches = tournament.events.filter(function(match, i) {
                    if (favoritesMap[match.uniqueId] !== undefined) {
                        matchesCount++;
                        return true;
                    } else {
                        return false;
                    }
                });
                
                if (matches.length > 0) {
                    preferitiTournaments.push({
                        ...tournament,
                        events: matches
                    });
                }
            });
            
            if (preferitiTournaments.length > 0) {
                preferitiCountries.push({
                    ...country,
                    tournaments: preferitiTournaments
                });
            }
        });
        
        if (preferitiCountries.length > 0) {
            preferitiSports.push({
                ...sport,
                categories: preferitiCountries
            });
        }
    });
    
    return {
        preferiti: preferitiSports,
        count: matchesCount
    };
}

function PreferitiSection(props) {
    const liveContext = useContext(LiveContext);
    const favoritesContext = useContext(FavoritesContext);
    const preferiti = getPreferiti(liveContext.data, favoritesContext.favorites);
    const conf = getConfiguration();

    let inEvidenzaSports = [];
    preferiti.preferiti.forEach(function(sport) {
        const competitions = [];
        sport.categories.forEach(function(country) {
            country.tournaments.forEach(function(competition) {
                competitions.push(competition);
            });
        });
        sport.competitions = competitions;
        inEvidenzaSports.push(sport);
    });

    const preferitiList = preferiti.preferiti.map(function(sport) {
        return <PreferitiSportItem key={sport.id} {...sport} isLive={props.isLive} />
    });

    return (
        <div className="card elemento-competizioni-widget">
            <div className="titolo-accordion maiuscolo bianco d-flex d-centro-v pointer toggle-nascondi-live tog-menu" data-toggle="collapse" data-parent="#accordionLaterale" href="#filtro-in-evidenza-content">
                <a href="#!" className="d-flex d-centro-v maiuscolo grassetto"><i className="fas fa-star margine-dx-mezzo giallo"></i>{getLabel('live_page.menu.favorites.title')}
                </a>
                <span> {conf.iwh ?  `(${preferiti.count})` : preferiti.count}</span>
            </div>
            <div id="filtro-in-evidenza-content" className="competzioni-sub collapse show in margine-su-mezzo" role="tabpanel" aria-labelledby="filtro-in-evidenza">
                {preferitiList.length === 0 ?
                    <span>{getLabel('live_page.menu.favorites.subtitle')}</span>
                    :
                    preferitiList
                }
            </div>
        </div>
    );
}
    
export default PreferitiSection;